import { render } from "./PublishDetails.vue?vue&type=template&id=3c19da1e&scoped=true"
import script from "./PublishDetails.vue?vue&type=script&lang=js"
export * from "./PublishDetails.vue?vue&type=script&lang=js"

import "./PublishDetails.vue?vue&type=style&index=0&id=3c19da1e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c19da1e"]])

export default __exports__